import QuestionsList from "./question-list";
import NewQuestion from "./question-new";
import QuestionDetail from "./question-detail";

export { NewQuestion, QuestionDetail };
export default QuestionsList;